import { render, staticRenderFns } from "./origin-select-trigger.vue?vue&type=template&id=052e019a&scoped=true"
import script from "./origin-select-trigger.vue?vue&type=script&lang=js"
export * from "./origin-select-trigger.vue?vue&type=script&lang=js"
import style0 from "./origin-select-trigger.vue?vue&type=style&index=0&id=052e019a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e019a",
  null
  
)

export default component.exports